// extracted by mini-css-extract-plugin
export default {"blockerContainer":"ub8TZmZ67QG80o7Vq8ut","blockerInnerContainer":"RRSl4lPL32t_uMoDMlBx","blockerImage":"zP5B2c8eYH7zMhpwD5dz","blockerTitle":"ohs4gTLModRU1w5BB5BJ"};